module.exports = __webpack_public_path__ + "media/images/iphone-mock-red-0a864e9fdaa8acea3fc867402f6d7efb.png";